import React, { useState, useEffect } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthMe } from "../lib/MyHttp";
import { Update } from "../lib/User";

// 국기 이미지
import img_flag_kr from "../assets/img_flag_kr.svg";
import img_flag_en from "../assets/img_flag_en.svg";
import img_flag_cn from "../assets/img_flag_cn.svg";
import img_flag_vi from "../assets/img_flag_vi.png";
import img_flag_th from "../assets/img_flag_th.png";

const languageImage = {
    ko: img_flag_kr,
    en: img_flag_en,
    cn: img_flag_cn,
    vi: img_flag_vi,
    th: img_flag_th
};

const languageText = {
    mn: "Монгол хэл",
    ko: "KOREA",
    en: "ENGLISH",
    ru: "RUSSIA"
};

const Header = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [headerClass, setHeaderClass] = useState("sub");

    const [data, setData] = useState();
    const [searchParams] = useSearchParams();

    const [langShow, setLangShow] = useState(false);

    useEffect(() => {
        let token = searchParams.get("token");
        if (!!token) {
            localStorage.setItem("fb_token", token);
        } else {
            token = localStorage.getItem("fb_token");
        }

        if (!!token && data) {
            data.fb_token = token;
            Update(
                data,
                res => {
                    localStorage.setItem("fb_token", "");
                },
                res => {}
            );
        }
    }, [searchParams, data]);

    useEffect(() => {
        if (location.pathname === "/") {
            setHeaderClass("main");
        } else {
            setHeaderClass("sub");
        }
    }, [location]);

    useEffect(() => {
        AuthMe(
            res => {
                setData(res);
            },
            res => {
                setData();
            }
        );

        return () => {};
    }, []);

    const clickLogout = () => {
        setData();
        localStorage.setItem("access_token", "");
        localStorage.setItem("refresh_token", "");
        localStorage.setItem("token_type", "");
        localStorage.setItem("expires_in", "");
        window.location = "/";
    };

    function langMenuToggle() {
        setLangShow(prev => !prev);
    }

    const clickReload = () => {
        window.location.replace("/");
    };

    return (
        <header className={`header-wrapper ${headerClass}`}>
            <div className="inner">
                <h1 className="logo">
                    <button onClick={() => clickReload()}>{t("효심")}</button>
                </h1>
            </div>

            <div className="language_02">
                <div className="language_top_wrapper">
                    <Link className={`language_top_select ${langShow ? "show" : ""}`} onClick={langMenuToggle}>
                        {languageText[i18n.language]}
                    </Link>

                    <ul className="language_top_list">
                        {Object.keys(languageText).map(key => {
                            if (i18n.language !== key) {
                                return (
                                    <li
                                        key={key}
                                        onClick={() => {
                                            i18n.changeLanguage(key);
                                            localStorage.setItem("lang", key);
                                            setLangShow(false);
                                        }}
                                    >
                                        <Link>{languageText[key]}</Link>
                                    </li>
                                );
                            }
                            return null;
                        })}
                    </ul>
                </div>
            </div>

            <Link className="Home_ico" onClick={() => clickReload()}></Link>
        </header>
    );
};

export default Header;
